import "./DeliveryJoinReq.css";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import { getTranslatedText as translate } from "../../../Localization/Translation";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import DetailedRequest from "./DetailedRequest/DetailedRequest";

const DeliveryJoinReq = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedLang));
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (laundryId) => {
    setShow(true);
  };
  const acceptReq = (id) => {
    document.getElementById(id).style.display = "none";
  };
  const rejectReq = (id) => {
    document.getElementById(id).style.display = "none";
  };

  var DelJoinReqs = [
    {
      id: 1,
      name: "عمار الأسعد",
      date: "25/12/2020",
      phone: "0968820968",
      relativePhone: "0968820967",
      relativeRelation: "قريب",
      nationality: "سعودي",
      IdOrPassport: "",
      Address: "عنوان الإفامة",
      VehicleType: "نوع المركبة",
      VehicleColor: "أحمر",
      VehicleNum: "رقم المركبة",
      VehicleLicence: "",
    },
    {
      id: 2,
      name: "ياسر النايف",
      date: "25/12/2020",
      phone: "0968820968",
      relativePhone: "0968820967",
      relativeRelation: "قريب",
      nationality: "سعودي",
      IdOrPassport: "",
      Address: "عنوان الإفامة",
      VehicleType: "نوع المركبة",
      VehicleColor: "أحمر",
      VehicleNum: "رقم المركبة",
      VehicleLicence: "",
    },
    {
      id: 3,
      name: "أسامة الشعار",
      date: "25/12/2020",
      phone: "0968820968",
      relativePhone: "0968820967",
      relativeRelation: "قريب",
      nationality: "سعودي",
      IdOrPassport: "",
      Address: "عنوان الإفامة",
      VehicleType: "نوع المركبة",
      VehicleColor: "أحمر",
      VehicleNum: "رقم المركبة",
      VehicleLicence: "",
    },
    {
      id: 4,
      name: "عمر الأبرش",
      date: "25/12/2020",
      phone: "0968820968",
      relativePhone: "0968820967",
      relativeRelation: "قريب",
      nationality: "سعودي",
      IdOrPassport: "",
      Address: "عنوان الإفامة",
      VehicleType: "نوع المركبة",
      VehicleColor: "أحمر",
      VehicleNum: "رقم المركبة",
      VehicleLicence: "",
    },
  ];

  let d = "-1";
  var DelJoinReqsList = DelJoinReqs.map((Req) => {
    d = Number(d) + 1;
    return (
      <div
        className={
          "request-card row animate__animated animate__fadeInLeft animate__delay-" +
          d +
          "s"
        }
        dir="auto"
        key={Req.id}
        id={Req.id}
      >
        <div
          className="col-md-5 request-card-col main-data-request-card-col"
          dir="auto"
        >
          <div className="header-join-req-card">
            <i className="fa fa-user" aria-hidden="true"></i>
            <span>{translate("delivery-person-name", locale)}:</span>
            <span>{Req.name}</span>
          </div>
          <div className="date-join-req-card">
            <i className="fa fa-calendar" aria-hidden="true"></i>
            <span>{translate("date-of-request", locale)}:</span>
            <span>{Req.date}</span>
          </div>
        </div>
        <div className="col-md request-card-col detail-btn-request-card-col">
          <button className="btn btn-primary" onClick={handleShow}>
            {translate("detail-request-button", locale)}
          </button>
        </div>
        <div className="col request-card-col approval-request-card-col">
          <button className="btn btn-primary" onClick={() => acceptReq(Req.id)}>
            <i className="fa fa-check" aria-hidden="true"></i>
            {translate("accept-request", locale)}
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => rejectReq(Req.id)}
          >
            <i className="fa fa-times" aria-hidden="true"></i>
            {translate("reject-request", locale)}
          </button>
        </div>
      </div>
    );
  });

  return (
    <div className="DeliveryJoinReq-component">
      {DelJoinReqsList}

      <Modal show={show} onHide={handleClose} size="md" dir="auto">
        <Modal.Header className="modal-header">
          {translate("detail-request-button", locale)}
        </Modal.Header>
        <Modal.Body>
          <DetailedRequest />
        </Modal.Body>
        <Modal.Footer dir="auto">
          <Button variant="secondary" onClick={handleClose}>
            {translate("modal-close-btn", locale)}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DeliveryJoinReq;
